module.exports = __webpack_public_path__ + "static/media/botox.d3021fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/botox.png
// module id = 265
// module chunks = 0